import asyncify from '../asyncify';

var supportsSymbol = typeof Symbol === 'function';

function isAsync(fn) {
    return supportsSymbol && fn[Symbol.toStringTag] === 'AsyncFunction';
}

function wrapAsync(asyncFn) {
    return isAsync(asyncFn) ? asyncify(asyncFn) : asyncFn;
}

export default wrapAsync;

export { isAsync };



//////////////////
// WEBPACK FOOTER
// ./~/async-es/internal/wrapAsync.js
// module id = 5ixj
// module chunks = 0